import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class CustomerSelectController extends Controller {
  static targets = ["customerSelect"];

  customerSelectTargetConnected(el) {
    this.selectedCustomerOption = this.getSelectedOptionFromDom(el);

    this.customerSelect = new SlimSelect({
      select: el,
      settings: {
        placeholderText: "Escolha...",
        searchText: "Nenhum resultado...",
        searchPlaceholder: "Pesquise...",
        searchingText: "Pesquisando...",
        allowDeselect: false,
        contentLocation: document.body,
      },
      events: {
        search: (search) => this.searchCustomers(search, el),
        afterChange: (customers) => {
          const customer = Array.isArray(customers) ? customers[0] : null;
          this.selectedCustomerOption = this.normalizeSelectedOption(customer);
        },
      },
    });
  }

  customerSelectTargetDisconnected() {
    if (this.customerSelectTimeout) {
      clearTimeout(this.customerSelectTimeout);
      this.customerSelectTimeout = null;
    }

    if (this.customerSelect) {
      this.customerSelect.destroy();
      this.customerSelect = null;
    }
  }

  async searchCustomers(search, selectElement) {
    if (this.customerSelectTimeout) clearTimeout(this.customerSelectTimeout);

    return await new Promise((resolve) => {
      this.customerSelectTimeout = setTimeout(async () => {
        const urlString = "/admin/customers/slim_select_search";
        const url = new URL(urlString, document.baseURI);
        url.searchParams.append("search", search);

        try {
          const response = await fetch(url);
          const data = await response.json();
          resolve(this.mergeSelectedOption(data, selectElement));
        } catch (error) {
          resolve([]);
        }
      }, 300);
    });
  }

  mergeSelectedOption(data, selectElement) {
    if (!Array.isArray(data)) return data;

    const selectedOption =
      this.getSelectedOptionFromDom(selectElement) ||
      this.selectedCustomerOption;

    if (!selectedOption || selectedOption.value === "") {
      return data;
    }

    const selectedValue = String(selectedOption.value);
    const selectedText = selectedOption.text || "";

    const hasSelectedOption = data.some(
      (option) => String(option.value) === selectedValue,
    );

    if (hasSelectedOption) {
      return data.map((option) => {
        if (String(option.value) !== selectedValue) return option;

        return {
          ...option,
          text: option.text || selectedText,
          selected: true,
        };
      });
    }

    return [{ ...selectedOption, selected: true }, ...data];
  }

  getSelectedOptionFromDom(selectElement) {
    const selectedOption = selectElement?.selectedOptions?.[0];

    if (!selectedOption) return null;

    return {
      value: selectedOption.value,
      text: selectedOption.text,
    };
  }

  normalizeSelectedOption(option) {
    if (!option || option.value === undefined || option.value === null) {
      return null;
    }

    return {
      value: option.value,
      text: option.text || "",
    };
  }
}
